
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-3xl font-bold mb-6">Ready to Strengthen Your AI Governance?</h3>
            <div className="space-y-4">
              <div className="flex items-center">
                <i className="ri-mail-line text-teal-400 text-xl mr-4"></i>
                <a 
                  href="mailto:counsel@aigovernance.legal" 
                  className="text-lg hover:text-teal-400 transition-colors cursor-pointer"
                >
                  counsel@aigovernance.legal
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="ri-linkedin-line text-teal-400 text-xl mr-4"></i>
                <a 
                  href="https://linkedin.com/in/aigovernancecounsel" 
                  target="_blank" 
                  rel="nofollow"
                  className="text-lg hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Connect on LinkedIn
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="ri-phone-line text-teal-400 text-xl mr-4"></i>
                <button 
                  onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                  className="text-lg hover:text-teal-400 transition-colors cursor-pointer"
                >
                  Schedule a Consultation Call
                </button>
              </div>
            </div>
          </div>
          
          {/* Quick Actions */}
          <div>
            <h3 className="text-2xl font-bold mb-6">Quick Actions</h3>
            <div className="space-y-4">
              <button 
                onClick={() => document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="block w-full text-left bg-red-600 hover:bg-red-7 00 px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-alarm-warning-line mr-3"></i>
                Emergency Compliance Assessment
              </button>
              
              <button 
                onClick={() => document.getElementById('services-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="block w-full text-left bg-teal-600 hover:bg-teal-700 px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-brain-line mr-3"></i>
                Strategic Policy Advisory
              </button>
              
              <button 
                onClick={() => window.open('https://medium.com/@aigovernancecounsel', '_blank')}
                className="block w-full text-left bg-gray-700 hover:bg-gray-600 px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer"
              >
                <i className="ri-book-open-line mr-3"></i>
                Read Academic Publications
              </button>
            </div>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-lg font-semibold">AI Governance Counsel</p>
              <p className="text-gray-400">Translating Complex Ethics &amp; Law into Policy, Foresight, and Liability Mitigation</p>
            </div>
            
            <div className="text-center md:text-right">
              <p className="text-gray-400">
                © 2024 AI Governance Counsel. All rights reserved.
              </p>
              <p className="text-sm text-gray-500 mt-1">
                <a href="https://readdy.ai/?origin=logo" target="_blank" rel="nofollow" className="hover:text-gray-300 cursor-pointer">
                  Website Builder
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
